// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Jn-z","badgeLink":"Kn-z","category":"Ln-z"};